module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/crm/kcc/bankmst/bankmst.component.scss
// module id = ./src/app/crm/kcc/bankmst/bankmst.component.scss
// module chunks = main